import React, { useState, useEffect, useMemo }  from 'react';
import { Route, Routes ,Navigate, useNavigate, useLocation} from 'react-router-dom';
import AppRoutes from './AppRoutes';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import Dashboard from './components/Dashboard';
import './custom.css';
import { history } from './helpers/history';
import { PrivateRoute } from './components/PrivateRoute';
import { Login } from './components/Login';
import Icon from "@mui/material/Icon";
import { ThemeProvider } from "@mui/material/styles";
import ArgonBox from "./components/dashdata/ArgonBox";
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import themeRTL from "./assets/theme/theme-rtl";
import CssBaseline from "@mui/material/CssBaseline";
import Sidenav from "./components/dashdata/Sidenav";
import Configurator from "./components/dashdata/Configurator";
import { useSelector, useDispatch } from 'react-redux';
import SettingsIcon from '@mui/icons-material/Settings';
function App() {

  history.navigate = useNavigate();
  history.location = useLocation();
  const [rtlCache, setRtlCache] = useState(null);
  // Cache for the rtl
  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });

    setRtlCache(cacheRtl);
  }, []);

  const page = useSelector(x => x.page);


  const layout = "dashboard";
  const configsButton = (
    <ArgonBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.5rem"
      height="3.5rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      //onClick={handleConfiguratorOpen}
    >
      <SettingsIcon />
    </ArgonBox>
  );

    return (
      <CacheProvider value={rtlCache}>
      <ThemeProvider theme={themeRTL}>
        <CssBaseline />
       
        {layout === "vr" && <Configurator />}
        <Routes>
          {AppRoutes.map((route, index) => {
            const { element, requireAuth, ...rest } = route;
            return <Route key={index} {...rest} element={requireAuth ? <AuthorizeRoute {...rest} element={element} /> : element} />;
          })}
        </Routes>
      </ThemeProvider>
    </CacheProvider>
        

    );
  }
  export default App;